import React from "react";

const Input = ({
  label,
  type = "text",
  value,
  onChange,
  placeholder,
  required = false,
  className = "",
}) => {
  return (
    <div className={className}>
      <label className="block text-sm font-medium text-[#00191A] mb-2">
        {label}
        {required && <span className="text-red-500">*</span>}
      </label>
      <input
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className="w-full px-4 py-2 rounded-xl bg-white border border-[#E1E1E1] focus:outline-none focus:border-[#14C5D1] text-[#00191A]"
      />
    </div>
  );
};

export default Input;

